module.exports = __webpack_public_path__ + "img/icon3.835e2f03.png";